module.exports = __webpack_public_path__ + "static/media/mds.47d17c93.svg";